import {forEach, getParent} from "../../../common/js/Helpers";

let checkout = null;

function _checkIfWeDealWithTheCorrectTrigger(e) {
    if (!e?.detail?.field) {
        return false;
    }

    let paymentBody = getParent(e.detail.field, '.payment-container').querySelector('#payment-form-braintree');

    if (!paymentBody) {
        return false;
    }

    return true;
}

function getForm() {
    return document.getElementById('payment-form-braintree');
}

document.addEventListener('eventgallery.payment.selected', (e)=> {

    if (!_checkIfWeDealWithTheCorrectTrigger(e)) return;

    let braintreeForm = getForm();

    if (checkout == null) {
        let clientToken = braintreeForm.getAttribute('data-token');
        forEach(document.querySelectorAll('input[name=paymentid]'), (e) => {e.setAttribute('disabled', 'disabled')})

        braintree.setup(clientToken, "dropin", {
            container: "payment-form-braintree",
            onReady: function (integration) {
                checkout = integration;
                forEach(document.querySelectorAll('input[name=paymentid]'), (e) => {e.removeAttribute('disabled')})
            }
        });
    }
});

document.addEventListener('eventgallery.payment.unselected', (e)=> {
    if (!_checkIfWeDealWithTheCorrectTrigger(e)) return;

    let braintreeForm = getForm();

    if (checkout !== null) {
        checkout.teardown(function () {
            checkout = null;
        });
    }
});


